import Service, { getCallApiFunction } from '../service'
import { TPreference } from '@/types/preference-tag'

type TResponse = {
  tagList: Array<TPreference>
}

class FetchAllPreferencesTagApi extends Service {
  constructor() {
    super()
    this.name = 'FETCH_ALL_PREFERENCES_TAG'

    this.config = {
      url: `/v1/livemall/preferences/all`,
      method: 'GET',
    }
  }
}

export const fetchAllPreferencesTag: () => TResponse = () => getCallApiFunction(new FetchAllPreferencesTagApi())
